module.exports = __webpack_public_path__ + "static/media/verifiedMark.46eadbc7.svg";